import history from "App/History";
import { Panel } from 'rsuite'
import { useTypedDispatch, useTypedSelector } from 'App/Store';
import { useEffect } from 'react';
import { DEFAULT_API_ERROR } from 'core/constants/Defaults';
import { useNotification } from 'shared/hooks/useNotification';
import { useParams } from 'react-router-dom';
import { hideLoader, showLoader } from "redux/action/loaderAction";
import { updateStore } from "core/services/Store";
import AddStoreForm from "components/AddStoreForm";
import { getStore, resetStoreDetails } from "redux/action/storeDetailsAction";

interface UrlParams {
  storeId: string;
}

export default function EditStore() {
  const showNotification = useNotification()
  const dispatch = useTypedDispatch()
  const urlParams = useParams<UrlParams>();
  const { store } = useTypedSelector((state) => state.store);

  useEffect(() => {
    dispatch(getStore(urlParams.storeId));
    return () => { dispatch(resetStoreDetails()) }
  }, [dispatch, urlParams.storeId])

  async function handleUpdateStore(storeData: any) {
    if (store?.id) {
      dispatch(showLoader())
      const formData = new FormData()
      formData.append('id', `${store.id}`)
      Object.entries(storeData).forEach(([key, value]: any) => {
        if (value instanceof File) {
          formData.append(key, value);
        } else if (Array.isArray(value) && value.every(v => v instanceof File)) {
          value.forEach((file) => {
            formData.append(key, file); 
          });      
        } else if (typeof value === "string") {
          formData.append(key, value);
        } else {
          formData.append(key, JSON.stringify(value));
        }
      });
      const spaceRes = await updateStore(formData, store.id)
      if (spaceRes.status) {
        showNotification({
          message: "Store Updated Successfully",
          title: "Success",
          type: "success",
        })
        history.push('/store')
      } else {
        showNotification({
          message: spaceRes.message || DEFAULT_API_ERROR,
          title: "Error",
          type: "error",
        })
      }
      dispatch(hideLoader())
    }
  }

  return (<>
    <Panel bordered shaded>
      <AddStoreForm
        onAddStore={handleUpdateStore}
        isEditMode={true}
        store={store}
      />
    </Panel>
  </>
  )
}